import { Injectable } from '@angular/core';
import { apisDataCacheKeys, ApiUrlConstant } from '@app-constants/app.constants';
import { RestApiService } from '@app-services/rest/rest-api.service';
import { resolve } from 'dns';
import { forkJoin, Observable } from 'rxjs';
import { filterCMSData} from '@app-helpers/functions';
import { NgxSpinnerService } from 'ngx-spinner';


@Injectable({
  providedIn: 'root'
})
export class SelfLearnService extends RestApiService {
  apiUrl = ApiUrlConstant.SELF_LEARN_API + '/api';
  apiUrlV2 = ApiUrlConstant.SELF_LEARN_API_V2 + 'api';
  cmsURl= ApiUrlConstant.cmsapi;
  // apiUrl = 'http://3.109.201.1/selflearnservice/api';
  playListVideo: any;
  selfLearnHomepagePlaylsit:any = {
    trendingVideosPlaylist:[],
    recommendedVideosPlayList:[],
    shortsVideosPlayList:[],
    puzzleVideosPlayList:[],
    listEnabled:false
  }
  filterCMSData = filterCMSData;
  getGradeId() {
    const userData = JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
    return userData?.grade?.gradeId;
  }

  getUserInfo() {
    const userData = JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
    return {
      phone_number: Number(userData.phone),
      email: userData?.email || "",
      userId: userData?.userId?.toString(),
      name: userData?.firstName + " " + userData.lastName,
      type: "free"
    }
  }

  getUserAcademics() {
    const userData = JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
    return {
      class: userData?.grade?.name,
      stream: userData?.stream?.name,
      target_exams: JSON.stringify(userData?.exams?.map((exam) => {
        let obj = {};
        obj[exam.name] = {
          exam_id: exam.examId,
          target_year : 0,
          exam_progress : 0,
          focused_exam : exam.name === (localStorage.getItem('examName') || localStorage.getItem('targetExamName'))
        };
        return obj;
      }))
    }
  }

  getHeaders() {
    if(JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))?.subTenant != null){
      return {
        tenantId: JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))?.tenantId.toString(),
        subTenantId:JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))?.subTenant.toString(),
      };
    }else{
      return {
        tenantId: JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))?.tenantId.toString(),
      };
    }
  }

  getReq(url: any) {
    return this.getWithHeaders(url, this.getHeaders());
  }

  postReq(url: any, payload: any) {
    return this.post(url, payload, this.getHeaders());
  }

  ////  SelfLearn V2.1

  putReq(url: any, payload: any) {
    return this.put(url, payload, this.getHeaders());
  }


  getSubtenantId(){
    return JSON.parse(localStorage.getItem(apisDataCacheKeys?.userDetails))?.subTenant;
  }

  getCmsExamID(){
    let cmsDetails = this.filterCMSData();
    return cmsDetails.map(e => String(e.CMS_Exam_id));
  }

  getChapterId(){
    return localStorage.getItem("chapterId");
  }

  getChapterName(){
    return localStorage.getItem("chapterName");
  }

  getSubjectId(){
    return localStorage.getItem("selfLearnSelectedSubject");

  }

  getTopicId(){
    return localStorage.getItem("selfLearnSelectedTopicId");
  }

  getTopicName(){
    return localStorage.getItem("selfLearnSelectedTopicName");
  }

  getVideoId(){
    return localStorage.getItem("selfLearnSelectedVideoId");
  }

  getPlayListId(){
    return localStorage.getItem('selfLearnSelectedPlayList');
  }

  getPracticeLevel(){
    return localStorage.getItem('currentLevel');
  }

  getSubtopicCount(){
    return localStorage.getItem('subtopicCount');
  }

  removlearnTabExpandRowIndex(){
    localStorage.removeItem('learnTabExpandIndex');
  }

  getVideosByPlayListId(params){
    let url =this.cmsURl +'video_playlist/get/videos/'+params.examId+'/'+params.subTenantId+'/'+params.playlistTypeId;
    let header = {
      'accesstoken': localStorage.getItem('token'),
      userId:this.getUserInfo()?.userId
    };
    return  this.getWithHeadersAndParams(url,header,{})
  }

  getVideoDetailsForPlatListTypeId(playlistTypeId){
    let url =this.apiUrlV2 +`/selflearn/getVideoDetailsForPlatListTypeId?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&playlistTypeId=${playlistTypeId}`;
    let header = {
      'accesstoken': localStorage.getItem('token'),
      userId:this.getUserInfo()?.userId,
      subTenantId:this.getSubtenantId(),
    };
    return  this.getWithHeadersAndParams(url,header,{})
  }

  getAllHomeScreenPlaylistVideos(playListIds){
    return new Promise((resolve, reject) => {
      if (this.selfLearnHomepagePlaylsit.listEnabled) {
        resolve(this.selfLearnHomepagePlaylsit)
      } else {
      this.selfLearnHomepagePlaylsit.playlist = [];
      const subTenantId  = JSON.parse(localStorage.getItem(apisDataCacheKeys?.userDetails))?.subTenant;
      // const details = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)).exams : [];
      // const examId = details.find(e => e.name.replaceAll(' ', '')?.toUpperCase() === localStorage.getItem('targetExamName'))?.examId
      let cmsDetails = this.filterCMSData();
      let cmsExamIds = cmsDetails.map(e => String(e.CMS_Exam_id));
      const trendingVideosParams = {
        examId: cmsExamIds,
        subTenantId: subTenantId,
        playlistTypeId: playListIds[0],
      }
      const recommendedVideosParams = {
        examId: cmsExamIds,
        subTenantId: subTenantId,
        playlistTypeId: playListIds[1],
      }
      const shortsVideosParams = {
        examId: cmsExamIds,
        subTenantId: subTenantId,
        playlistTypeId: playListIds[2],
      }
      const PuzzleVideosParams = {
        examId: cmsExamIds,
        subTenantId: subTenantId,
        playlistTypeId: playListIds[3],
      }
      forkJoin([this.getVideosByPlayListId(trendingVideosParams), this.getVideosByPlayListId(recommendedVideosParams), this.getVideosByPlayListId(shortsVideosParams), this.getVideosByPlayListId(PuzzleVideosParams)]).subscribe((data:any) => {
        this.selfLearnHomepagePlaylsit.trendingVideosPlaylist = this.getVideosFromPlaylist(data?.[0].data);//this.returnVideosMouldList(data?.[0].data);
        this.selfLearnHomepagePlaylsit.recommendedVideosPlayList = this.getVideosFromPlaylist(data?.[1].data); //this.returnVideosMouldList(data?.[1].data);
        this.selfLearnHomepagePlaylsit.shortsVideosPlayList = this.getVideosFromPlaylist(data?.[2].data); //this.returnVideosMouldList(data?.[2]);
        this.selfLearnHomepagePlaylsit.puzzleVideosPlayList = this.getVideosFromPlaylist(data?.[3].data); //this.returnVideosMouldList(data?.[3]);
        resolve(this.selfLearnHomepagePlaylsit)
      },
      (err)=>{
        resolve(this.selfLearnHomepagePlaylsit)
        // reject(err)
      })
      }
    })
  }

  returnVideosMouldList(list){
    return {
      id:list?.data?.playlistId,
      playlistTypeId:list?.data?.playlistTypeId,
      name:list?.data?.playListTitle,
      videos:list?.data?.videos?.map((e)=>{
        e.durationSecs = e.duration;
        e.duration=this.secondsToTime(e.duration);
        return e
      })
    }
  }

  getVideosFromPlaylist(playlistarr){
    let videosList:any = [];
    playlistarr.forEach(playList => {
      playList.videos.forEach(element => {
        videosList.push(element);
     });
    });
    return videosList;
  }

  getWidgetOrders(){
    const url = this.apiUrlV2 + `/selflearn/widgetorders`;
    return this.getReq(url);
  }

  getChaptersForExamAndSubject(subjectId){
    // const details = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)).exams : [];
    // const examId = details.find(e => e.name.replaceAll(' ', '')?.toUpperCase() === localStorage.getItem('targetExamName'))?.examId
    let cmsDetails = this.filterCMSData();
    let cmsExamIds = cmsDetails.map(e => String(e.CMS_Exam_id));
    const subTenantId  = JSON.parse(localStorage.getItem(apisDataCacheKeys?.userDetails))?.subTenant;
    let url = this.cmsURl + `examtoc/getChaptersForExamSubjectSubtenant?examId=${cmsExamIds}&subjectId=${subjectId}&subtenantId=${subTenantId}`;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
       'userId': this.getUserInfo()?.userId,
    };
    return this.getWithHeaders<any>(url,headers);
  }

  getTopicsAndVideosForExamChapterSubtenant(chapterId){
    let cmsDetails = this.filterCMSData();
    let cmsExamIds = cmsDetails.map(e => String(e.CMS_Exam_id));
    const subTenantId  = JSON.parse(localStorage.getItem(apisDataCacheKeys?.userDetails))?.subTenant;
    let url = this.cmsURl + `examtoc/getTopicsAndVideosForExamChapterSubtenant?chapterId=${chapterId}&examId=${cmsExamIds}&subtenantId=${subTenantId}`;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
       'userId': this.getUserInfo()?.userId,
    };
    return this.getWithHeaders<any>(url,headers);
  }

  getTopicAndVideosProgress(subjectId, chapterId){
    let cmsDetails = this.filterCMSData();
    let cmsExamIds = cmsDetails.map(e => String(e.CMS_Exam_id));
    const url = this.apiUrlV2 + `/selflearn/getTopicAndVideosProgress?examId=${cmsExamIds}&gradeId=${this.getGradeId()}&subjectId=${subjectId}&chapterId=${chapterId}`;
    return this.getReq(url);
  }

  getVideoProgressByTopic(){
    const url = this.apiUrlV2 + `/selflearn/getVideoProgressByTopic?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&subjectId=${this.getSubjectId()}&chapterId=${this.getChapterId()}&topicId=${this.getTopicId()}`;
    return this.getReq(url);
  }

  getChapterProgress(subjectId){
    // const details = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)).exams : [];
    // const examId = details.find(e => e.name.replaceAll(' ', '')?.toUpperCase() === localStorage.getItem('targetExamName'))?.examId
    let cmsDetails = this.filterCMSData();
    let cmsExamIds = cmsDetails.map(e => String(e.CMS_Exam_id));
    const url = this.apiUrlV2 + `/selflearn/getChapterProgress?examId=${cmsExamIds}&gradeId=${this.getGradeId()}&subjectId=${subjectId}`;
    return this.getReq(url);
  }

  storeVideoProgress(payload){
    const url = this.apiUrlV2 + `/selflearn/storeVideoProgress`;
    return this.putReq(url, payload);
  }

  getTopicsByChapterExamSubtenant(){
    let url = this.cmsURl + `examtoc/chapter/Topics/getTopicsByChapterExamSubtenant?chapterId=${this.getChapterId()}&examId=${this.getCmsExamID()}&subtenantId=${this.getSubtenantId()}`;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
       'userId': this.getUserInfo()?.userId,
    };
    return this.getWithHeaders<any>(url,headers);
  }

  getPracticeProgress(){
    const url = this.apiUrlV2 + `/practice/getPracticeProgress?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&subjectId=${this.getSubjectId()}&chapterId=${this.getChapterId()}`;
    return this.getReq(url);
  }

  submitAndGetPracticeQuestionsV2(payload: any): Observable<any> {
    const url = this.apiUrlV2 + "/practice/submitAndGetPracticeQuestions";
    return this.postReq(url, payload);
  }

  publishedVideoAndFlashcardCount(){
    let url = this.cmsURl + `examtoc/chapter/Topics/publishedVideoAndFlashcardCount?chapterId=${this.getChapterId()}&examId=${this.getCmsExamID()}&subtenantId=${this.getSubtenantId()}`;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
        'userId': this.getUserInfo()?.userId
    };
    return this.getWithHeaders<any>(url,headers);
  }

  getTopicSummaryProgress(){
    const url = this.apiUrlV2 + `/selflearn/getTopicSummaryProgress?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&subjectId=${this.getSubjectId()}&chapterId=${this.getChapterId()}`;
    return this.getReq(url);
  }

  getFlashcardsAndQuestions(){
    let url = this.cmsURl + `flashcard/flashcardsAndQuestions/${this.getTopicId()}/1`;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
        'userId': this.getUserInfo()?.userId
    };
    return this.getWithHeaders<any>(url,headers);
  }

  updateTopicSummaryProgress(payload){
    const url = this.apiUrlV2 + `/selflearn/updateTopicSummaryProgress`;
    return this.putReq(url, payload);
  }

  getTopicSummaryAndQuestions(){
    const url = this.apiUrlV2 + `/selflearn/getTopicSummaryAndQuestions?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&subjectId=${this.getSubjectId()}&chapterId=${this.getChapterId()}&topicId=${this.getTopicId()}`;
    return this.getReq(url);
  }

  getStoriesForExamNodeIds(){
    const arr = [this.getCmsExamID()];
    let url = this.cmsURl + `story/getStoriesForExamNodeIds?examIds=${arr}&examNodeIds=${this.getChapterId()}`;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
        'userId': this.getUserInfo()?.userId
    };
    return this.getWithHeaders<any>(url,headers);
  }

  getPracticeAnalysis(){
    const url = this.apiUrlV2 + `/practice/getPracticeAnalysis?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}&subjectId=${this.getSubjectId()}&chapterId=${this.getChapterId()}&topicId=${this.getTopicId()}`;
    return this.getReq(url);
  }

  getResumeLearningForHomeScreen(){
    const url = this.apiUrlV2 + `/selflearn/getResumeLearningForHomeScreen?examId=${this.getCmsExamID()}&gradeId=${this.getGradeId()}`;
    return this.getReq(url);
  }

  getResumeVideos(examId,gradeId){
    const url = this.apiUrlV2 + `/selflearn/getResumeVideos?examId=${examId}&gradeId=${gradeId}&limit=1`;
    return this.getReq(url);
  }

  

  ////  SelfLEarn V1

  getSubjectsBasedOnExamtype(examId: any, userId:any): Observable<any> {
    const url = this.apiUrl + `/selflearn/v2/getUserSubjectsPerExam?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}`;
    return this.getReq(url);
  }

    //Get Subject Exam wise
  getSubjectsForExam(userId: any, examId: any) {
    let url = this.cmsURl + `examtoc/v2/getSubjectsForExam/${examId}?status=${"active"}&subtenantIds=${this.getSubtenantId()}`;
    let headers = {
      'authorization': 'Bearer ' + localStorage.getItem('token'),
      'userId': userId + ""
    };
    return this.getWithHeaders<any>(url, headers);
  }

  getChaptersBasedOnSubjectAndExamtype(examId: any, userId:any, subjectId: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/getUserChaptersForExamAndSubject?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}&subjectId=${subjectId}`;
    return this.getReq(url);
  }

  // updateChapterUnlockStatus(payload: any): Observable<any> {
  //   const url = this.apiUrl + `/selflearn/updateChapterUnlockStatus`;
  //   return this.postReq(url, payload);
  // }

  updateChapterUnlockStatus(payload: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/v2/updateChapterUnlockStatus`;
    return this.postReq(url, payload);
  }

  getTopicsBasedOnChapter(examId: any, userId:any, subjectId: any, chapterId: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/topicsAndSubtopics?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}&subjectId=${subjectId}&chapterId=${chapterId}`;
    return this.getReq(url);
  }

  getVideosbasedonChapter(examId: any, userId:any, subjectId: any, chapterId: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/topicsAndVideos?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}&subjectId=${subjectId}&chapterId=${chapterId}`;
    return this.getReq(url);
  }
  // getTopicInfobasedOnChapter(chapterId: any): Observable<any> {
  //   const url = this.apiUrl + `/selflearn/usertopic/${chapterId}`;
  //   return this.getReq(url);
  // }

  getFlashCardContentForUser(examId: any, userId:any, subjectId: any, chapterId: any, topicId: any, subTopicId: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/getuserflashcardsAndQuestions?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}&subjectId=${subjectId}&chapterId=${chapterId}&topicId=${topicId}&subtopicId=${subTopicId}`;
    return this.getReq(url);
  }

  updateBookmarkForWholeDeck(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/flashcard";
    return this.postReq(url, payload);
  }

  saveFeedback(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/flashcard/feedback";
    return this.postReq(url, payload);
  }

  raiseAnErrorForIndividualFlashCard(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/flashcard/errors";
    return this.postReq(url, payload);
  }

  raiseAnErrorForIndividualQuestion(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/flashcard/errors/questions";
    return this.postReq(url, payload);
  }

  rateOverallFlashCard(payload: any) {
    const url = this.apiUrl + "/learn/flashcard/feedback/flashcarddeck";
    return this.postReq(url, payload);
  }

  updateBookmarkForVideo(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/video";
    return this.postReq(url, payload);
  }

  updateBookmarkForVideoForPlaylist(payload: any): Observable<any> {
    const url = this.apiUrl + "/selflearn/v2";
    return this.postReq(url, payload);
  }

  raiseAnErrorForIndividualVideo(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/video/errors";
    return this.postReq(url, payload);
  }

  // practice services

  getAllTopicsForPractice(examId: any, userId:any, subjectId: any, chapterId: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/getUserTopicsForExamAndSubjectAndChapter?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}&subjectId=${subjectId}&chapterId=${chapterId}`;
    return this.getReq(url);
  }

  submitAndGetPracticeQuestions(payload: any): Observable<any> {
    const url = this.apiUrl + "/practice/submitAndGetPracticeQuestions";
    return this.postReq(url, payload);
  }

  rateOverallPractice(payload: any) {
    const url = this.apiUrl + "/practice/feedback";
    return this.postReq(url, payload);
  }

  raiseAnErrorForPracticeQuestion(payload: any): Observable<any> {
    const url = this.apiUrl + "/practice/errors";
    return this.postReq(url, payload);
  }

  // practice services

  getBookmarksForUserBasedOnExamAndSubject(examId: any, userId:any, subjectId: any): Observable<any> {
    const url = this.apiUrl + `/selflearn/bookmarkeditems?examid=${examId}&gradeId=${this.getGradeId()}&userid=${userId}&subject=${subjectId}`;
    return this.getReq(url);
  }

  raiseAnErrorForIndividualQuestionInbookmarks(payload: any): Observable<any> {
    const url = this.apiUrl + "/practice/errors";
    return this.postReq(url, payload);
  }

  submitIndividualQuestionInbookmarks(payload: any): Observable<any> {
    const url = this.apiUrl + "/practice/submitAndGetPracticeQuestions";
    return this.postReq(url, payload);
  }

  saveVideoFeedback(payload: any): Observable<any> {
    const url = this.apiUrl + "/learn/video/feedback";
    return this.postReq(url, payload);
  }

  getVideoCompletePercentageAnalytics(): Observable<any> {
    const url = this.apiUrl + `/configuration/getVideoCompletePercentageforAnalytics`;
    return this.getReq(url);
  }

  getEventTriggeredStatusForUser(userId: any, eventType: any): Observable<any> {
    const url = this.apiUrl + `/events/getObjectEventStatusforUser/${userId}/${eventType}`;
    return this.getReq(url);
  }

  updateEventTriggeredStatusForUser(payload: any): Observable<any> {
    const url = this.apiUrl + `/events/updateObjectEventStatusforUser`;
    return this.postReq(url, payload);
  }

  // articulation apis

  getUserStoriesBasedOnChapter(examId: any, chapterId: any): Observable<any> {
    const url = this.apiUrl + `/articulation/getUserStoriesAndDetailsforChapter?examId=${examId}&gradeId=${this.getGradeId()}&chapterId=${chapterId}`;
    return this.getReq(url);
  }

  getStoryBasedOnId(examId:any, storyId: any): Observable<any> {
    const url = this.apiUrl + `/articulation/getUserStoryDetails?examId=${examId}&gradeId=${this.getGradeId()}&storyId=${storyId}`;
    return this.getReq(url);
  }

  updateStoryStatus(payload: any): Observable<any> {
    const url = this.apiUrl + `/articulation/updateStoryStatus`;
    return this.postReq(url, payload);
  }
  //?recommended videos
  getRecommendedVideos(examId:any, userId: any){
    // https://selflearnapi.devinfinitylearn.in/api/selflearn/recommendedVideos?examId=1&gradeId=11&userId=290258
    // const url = this.apiUrl + `/articulation/getUserStoriesAndDetailsforChapter?examId=${examId}&gradeId=${this.getGradeId()}&chapterId=${chapterId}`;
    const url = this.apiUrl + `/selflearn/recommendedVideos?examId=${examId}&gradeId=${this.getGradeId()}&userId=${userId}`;
    return this.getReq(url);
  }
  getVideoPlayList(params){
    params.gradeId = this.getGradeId();
    const url = this.apiUrl + `/selflearn/v2/playlists`;
    return this.getWithHeadersAndParams(url,{},params )
  }
  get_video(videoid,params?){
  params.userId = this.getUserInfo()?.userId
    const url = this.apiUrl +`/selflearn/v2/videoSolution/`+videoid;
    return this.getWithHeadersAndParams(url,{},params )
  }
  getVideoCms(videoid){
    let url =this.cmsURl +'videos/get_video/'+videoid
    let header = {
      userId:this.getUserInfo()?.userId
  }
  return  this.getWithHeadersAndParams(url,header,{})
  }
  updateWatchedVideoSolution(payload){
    const url = this.apiUrl + "/selflearn/v2/videoSolution/";
    return this.postReq(url, payload);
  }
  getHomeScreenPlaylist(examId?,userId?){
 var mouldList = (list)=>{
    return {
      id:list?.playlistId,
      playlistTypeId:list?.playlistTypeId,
      name:list?.playListTitle,
      videos:list?.videos?.map((e)=>{
        e.durationSecs = e.duration;
        e.duration=this.secondsToTime(e.duration);
        return e
      })
    }
  }
    return new Promise((resolve, reject) => {
      if (this.selfLearnHomepagePlaylsit.listEnabled) {
        resolve(this.selfLearnHomepagePlaylsit)
      } else {
        this.selfLearnHomepagePlaylsit.playlist = [];
        if(!examId){
          const details = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)).exams : [];
          examId = details.find(e => e.name.replaceAll(' ', '')?.toUpperCase() === localStorage.getItem('targetExamName'))?.examId
        }
        userId = this.getUserInfo()?.userId
        let videoPlayListParams = {
          examId: examId,
          playListTypeId: 1,
          userId: this.getUserInfo()?.userId
        }
        let reelPlayListParams = {
          examId: examId,
          playListTypeId: 2,
          userId: this.getUserInfo()?.userId
        }
          // ,this.getVideoPlayList(params), this.getRecommendedVideos(examId, userId)
        forkJoin([this.getVideoPlayList(videoPlayListParams), this.getVideoPlayList(reelPlayListParams)]).subscribe((data:any) => {
          let plalistdata = [];
          if(data?.[0]?.playlists?.length) {
            plalistdata = [...plalistdata, ...data?.[0]?.playlists];
          }
          if(data?.[1]?.playlists?.length) {
            plalistdata = [...plalistdata, ...data?.[1]?.playlists];
          }
          plalistdata?.sort((playlist1, playlist2) => playlist1?.playlistId - playlist2?.playlistId)
            ?.forEach(playlist => {
              let list1 = mouldList(playlist)
              this.selfLearnHomepagePlaylsit.playlist.push(list1)
            });         
          resolve(this.selfLearnHomepagePlaylsit)
        },
        (err)=>{
        resolve(this.selfLearnHomepagePlaylsit)
          // reject(err)
        })
      }
    })
  }
  secondsToTime(e, isWithLabels?) {
    if(e){
        let split_string = e?.split(/(\d+)/);
        let h = Math.floor(split_string?.[1] / 3600),
            m = Math.floor(split_string?.[1] % 3600 / 60),
            s = Math.floor(split_string?.[1] % 60);
        let result = s?.toString()?.padStart(2,'0') +'s';
        if(!!h){
            result = (isWithLabels && isWithLabels == true) ? (h?.toString()?.padStart(2,'0') + 'h ' + m?.toString()?.padStart(2,'0') + 'm ' + s?.toString()?.padStart(2,'0') +'s') :
            (h?.toString()?.padStart(2,'0') + ':' + m?.toString()?.padStart(2,'0') + ':' + s?.toString()?.padStart(2,'0') +'');
        }
        else if(!!m){
            result = (isWithLabels && isWithLabels == true) ? (m?.toString()?.padStart(2,'0') + 'm ' + s?.toString()?.padStart(2,'0') +'s'):
            (m?.toString()?.padStart(2,'0') + ':' + s?.toString()?.padStart(2,'0') +'')
        }

        return result;
    }
    else{
        return 0 + 'sec';
    }
  }
}
